// extracted by mini-css-extract-plugin
export default {"root":"styles_root__wctx-","new":"styles_new__GHU6c"};